var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoncredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 5,
    y: 6,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#086D2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2336 15H9L10.927 10H12.0803L14 15H12.7445L12.365 13.9459H10.6204L10.2336 15ZM11.3504 11.9595L10.9635 13.027H12.0292L11.6423 11.9595C11.5839 11.7905 11.5182 11.5946 11.4964 11.473C11.4745 11.5878 11.4161 11.777 11.3504 11.9595Z",
    fill: "#086D2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.77778V10.9259H18M18.7405 15.3315C18.1554 17.0692 17.0478 18.5603 15.5846 19.5801C14.1215 20.5999 12.3821 21.0931 10.6285 20.9855C8.8749 20.8779 7.20216 20.1752 5.86233 18.9833C4.5225 17.7915 3.58818 16.1751 3.20015 14.3777C2.81211 12.5802 2.9914 10.6992 3.711 9.01795C4.43059 7.33673 5.65149 5.94643 7.18974 5.05655C8.72798 4.16667 10.5002 3.82543 12.2394 4.08425C13.9786 4.34307 15.5905 5.18792 16.8322 6.4915L21 10.6093",
    stroke: "#086D2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoncredit);
export default __webpack_public_path__ + "static/media/noncredit.3c465ab5a6a85ee857f86feb99605109.svg";
export { ForwardRef as ReactComponent };